import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, useTick } from '@pixi/react';
import { useCallback, useRef } from 'react';
import { shallowEqual } from 'react-redux';
import { removeTableShakeAnimation } from '../../redux/actions/animationsActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { getRemainingTimeRatio } from '../../utils/animationUtils';
import { assertUnreachable } from '../../utils/tsUtils';
function tableShakeAnimationsEqualityFn(a, b) {
    return shallowEqual(a.map(({ id }) => id), b.map(({ id }) => id));
}
export const TableShakeAnimationContainer = ({ children, handleAnimationRemovals }) => {
    const dispatch = useAppDispatch();
    const tableShakeAnimations = useAppSelector((state) => state.animations.tableShakeAnimations, tableShakeAnimationsEqualityFn);
    const containerRef = useRef(null);
    const animate = useCallback(() => {
        if (!containerRef.current) {
            return;
        }
        let totalX = 0;
        let totalY = 0;
        const nowMs = performance.now();
        tableShakeAnimations.forEach((tableShakeAnimation) => {
            const { id, startTimestampMs, type, durationMs } = tableShakeAnimation;
            if (nowMs >= startTimestampMs + durationMs) {
                if (handleAnimationRemovals) {
                    dispatch(removeTableShakeAnimation(id));
                }
            }
            else {
                switch (type) {
                    case 'vibrate': {
                        const remainingTimeRatio = getRemainingTimeRatio(startTimestampMs, durationMs, nowMs);
                        const currVibrateStrength = tableShakeAnimation.isIncreasingStrength
                            ? 1 - remainingTimeRatio
                            : remainingTimeRatio;
                        const currMaxVibrateDeltaPx = tableShakeAnimation.maxVibratePx * currVibrateStrength;
                        totalX += Math.random() * currMaxVibrateDeltaPx - currMaxVibrateDeltaPx / 2;
                        totalY += Math.random() * currMaxVibrateDeltaPx - currMaxVibrateDeltaPx / 2;
                        break;
                    }
                    default: {
                        assertUnreachable(type);
                    }
                }
            }
        });
        containerRef.current.x = totalX;
        containerRef.current.y = totalY;
    }, [tableShakeAnimations, dispatch, handleAnimationRemovals]);
    useTick(animate, tableShakeAnimations.length > 0);
    return _jsx(Container, { ref: containerRef, children: children });
};
